/* dp-search-collapse.js - groups combined-listing children into one result per
 * family on /search. Map + config come from <script id="dp-collapse-map"> in
 * sections/dp-search-collapse.liquid; row = {h child, p parent, t title, l label}.
 * No requestAnimationFrame here: rAF is not serviced in a hidden document. */
(function () {
  'use strict';

  var map = Object.create(null);
  var cfg = { sectionId: '', labelMany: 'options available', urlBase: '' };

  function mapEl(root) {
    return (root || document).querySelector('#dp-collapse-map');
  }

  function loadMap(root) {
    var el = mapEl(root);
    if (!el) return false;
    cfg.sectionId = el.getAttribute('data-section-id') || cfg.sectionId;
    cfg.labelMany = el.getAttribute('data-label-many') || cfg.labelMany;
    cfg.urlBase = el.getAttribute('data-url-base') || cfg.urlBase;
    var rows;
    try { rows = JSON.parse(el.textContent || '[]'); } catch (e) { return false; }
    if (!Array.isArray(rows)) return false;
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r && r.h && r.p) map[r.h] = { p: r.p, t: r.t || '', l: r.l || '' };
    }
    return true;
  }

  function productList() {
    return document.querySelector('product-list.product-list');
  }

  function rewrite(card, entry) {
    var href = cfg.urlBase + '/products/' + entry.p;
    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', href);
      links[i].removeAttribute('data-instant');
    }
    if (entry.t) {
      var titleLink = card.querySelector('.product-card__title a');
      if (titleLink) titleLink.textContent = entry.t;
      var img = card.querySelector('img[alt]');
      if (img) img.setAttribute('alt', entry.t);
    }
  }

  function setCount(card, count, entry) {
    var host = card.querySelector('.product-card__title');
    if (!host) return;
    var badge = card.querySelector('.dp-collapse-count');
    if (count < 2) { if (badge) badge.remove(); return; }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'dp-collapse-count';
      host.insertAdjacentElement('afterend', badge);
    }
    var text = count + ' ' + ((entry && entry.l) ? entry.l : cfg.labelMany);
    if (badge.textContent !== text) badge.textContent = text;
  }

  function show(card) {
    if (card.getAttribute('data-dp-dropped') === '1') {
      card.removeAttribute('data-dp-dropped');
      card.hidden = false;
    }
  }

  // Recounts every family from scratch each pass, so re-runs never leave a stale badge.
  function collapse() {
    var list = productList();
    if (!list) return null;
    var cards = list.querySelectorAll('product-card[handle]');
    if (!cards.length) return null;

    var kept = Object.create(null);
    var unknown = [];

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var handle = card.getAttribute('handle');
      if (!handle) continue;

      var entry = map[handle];
      if (!entry) {
        // Standalone product, or a child not mapped yet; run() decides on a refresh.
        show(card);
        unknown.push(handle);
        continue;
      }

      var existing = kept[entry.p];
      if (existing) {
        existing.count += 1;
        card.setAttribute('data-dp-dropped', '1');
        card.hidden = true;
        continue;
      }

      kept[entry.p] = { card: card, count: 1, entry: entry };
      show(card);
      if (card.getAttribute('data-dp-rewritten') !== '1') {
        rewrite(card, entry);
        card.setAttribute('data-dp-rewritten', '1');
      }
    }

    Object.keys(kept).forEach(function (p) {
      setCount(kept[p].card, kept[p].count, kept[p].entry);
    });
    return unknown;
  }

  var refreshing = false;

  function refreshMap() {
    if (refreshing || !cfg.sectionId) return;
    refreshing = true;
    var before = Object.keys(map).length;

    // Force type=product: with several result types the page's search.results is
    // mixed but the grid is loaded from ?type=product, so the map must match that.
    var params = new URLSearchParams(location.search);
    params.set('type', 'product');
    params.set('section_id', cfg.sectionId);

    fetch(location.pathname + '?' + params.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        loadMap(new DOMParser().parseFromString(html, 'text/html'));
        if (Object.keys(map).length > before) collapse();
      })
      .catch(function () { /* a failed refresh just means no collapsing */ })
      .then(function () { refreshing = false; });
  }

  // Refresh only for handles not yet tried; standalones stay unknown forever and
  // would otherwise trigger a fetch on every mutation.
  var attempted = Object.create(null);

  function run() {
    var unknown = collapse();
    if (!unknown || !unknown.length) return;
    var fresh = false;
    for (var i = 0; i < unknown.length; i++) {
      if (!attempted[unknown[i]]) { attempted[unknown[i]] = true; fresh = true; }
    }
    if (fresh) refreshMap();
  }

  var runTimer = null;
  function scheduleRun() {
    clearTimeout(runTimer);
    runTimer = setTimeout(run, 30);
  }

  // Observe the whole search section, not the grid: the grid is missing from the
  // initial HTML when search returns >1 type (lazy <search-result-panel>), and is
  // replaced wholesale on facet/pagination changes. run() is idempotent.
  var observer = null;
  var observedHost = null;

  function watch() {
    if (!window.MutationObserver) return;
    var host = document.querySelector('.shopify-section--main-search') || document.body;
    if (host === observedHost) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(scheduleRun);
    observer.observe(host, { childList: true, subtree: true });
    observedHost = host;
  }

  function init() {
    loadMap(document);
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // facet-link swaps the grid via the Section Rendering API; theme fires this.
  document.addEventListener('shopify:section:load', init);
})();
